import type { StyleRule } from '@archipro-design/aria';
import { imageClassName } from '@archipro-design/aria';
import { gridClassName, buttonClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem, labelClassName } from '@archipro-design/aria';

export const LocationDetailWrap: StyleRule = ({ theme }) => ({
    // location details grid
    [`& > .${gridClassName}`]: {
        flexGrow: 1,
    },
    borderBottom: `1px solid ${theme.siteVariables.colors.grey[100]}`,
    padding: pxArrayToRem([20, 18]),
});

export const LocationAvatar: StyleRule = () => ({
    marginRight: pxToRem(16),
    [`& .${imageClassName}`]: {
        width: '100%',
        height: '100%',
    },
    '& img': {
        padding: pxToRem(3),
    },
});

export const LocationType: StyleRule = ({ theme }) => ({
    height: pxToRem(18),
    marginBottom: pxToRem(8),
    // location type text
    '& > div:first-child': {
        flexGrow: 1,
        fontSize: pxToRem(12),
        ...theme.siteVariables.textStyles.Heading.Roman55,
        color: theme.siteVariables.colors.charcoal[100],
        textTransform: 'uppercase',
    },
    // distance text: xx km
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(14),
        lineHeight: 1,
        paddingRight: pxToRem(4),
    },
    // map pin icon
    '& > div.map-pin': {
        fontSize: pxToRem(16),
        '& span': {
            width: pxToRem(16),
            height: pxToRem(16),
            marginTop: pxToRem(-11),
        },
    },
});

export const LocationTitle: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(18),
    marginBottom: pxToRem(18),
    ...theme.siteVariables.textStyles.Heading.Roman55,
    textTransform: 'uppercase',
    fontSize: theme.siteVariables.fontSizes.caption04,
});

export const LocationAddress: StyleRule = () => ({
    minHeight: pxToRem(18),

    // clickToReveal text with ellipsis
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(14),
        lineHeight: 1.5,
    },
});

export const LocationPhone: StyleRule = ({ theme }) => ({
    ...LocationAddress({ theme }),
    marginTop: pxToRem(-3),
});

export const LocationOrder: StyleRule = ({ theme }) => ({
    ...LocationAddress({ theme }),
    marginTop: pxToRem(-2),
});

export const ClickAndCollectAvailable: StyleRule = () => ({
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(14),
        lineHeight: 1.5,
    },
});

export const LocationActions: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([12, 8, -2, 0]),
    height: pxToRem(40),
    gap: pxToRem(8),
    '& div': {
        letterSpacing: 0,
    },

    // view profile button
    '& > div:first-child a': {
        margin: pxArrayToRem([12, 9, 0, 0]),
        textDecorationLine: 'underline',
    },

    // enquire button
    '& > div:nth-child(2)': {
        width: pxToRem(81),
        textAlign: 'right',
        [`& .${buttonClassName}`]: {
            padding: pxArrayToRem([16, 12, 16, 12]),
            height: pxToRem(40),
            background: theme.siteVariables.colors.white[300],
        },
    },
    // heart button
    '& > div:last-child': {
        width: pxToRem(30),
        marginTop: pxToRem(-3),
    },
});

export const EnquireButton: StyleRule = () => ({
    padding: pxArrayToRem([16, 25]),
    width: '100%',
    textTransform: 'uppercase',
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(15),
        lineHeight: pxToRem(16.5),
    },
});

export const SaveToDesignBoardButton: StyleRule = () => ({
    border: `1.5px solid #222222`,
    width: pxToRem(48),
    height: `100%`,
    backgroundColor: '#FFFFFF',
    color: '#222222',
    '&:hover': {
        border: `1.5px solid #222222 !important`,
        backgroundColor: '#FFFFFF !important',
    },
    '&:active': {
        border: `1.5px solid #222222 !important`,
        backgroundColor: '#FFFFFF !important',
    },

    [`&.${buttonClassName}`]: {
        padding: 0,
    },
});

export const EnquiryAndSaveWrapper: StyleRule = () => ({
    marginTop: pxToRem(20),
    height: pxToRem(48),
});

export const ViewProfileButton: StyleRule = ({ theme }) => ({
    [`& .${labelClassName}`]: {
        fontSize: theme.siteVariables.fontSizes.caption04,
        lineHeight: 1,
        textDecoration: 'underline',
    },
});
